import type { ActionBinding } from "./ActionBinding.type"
import createActionBinding from "./createActionBinding"
import createKeyboardBinding from "./createKeyboardBinding"
import createMouseClickBinding from "./createMouseClickBinding"
import { InputActionType } from "./InputActionType"
import { MouseButton } from "./MouseButton.enum"

// TODO: Dawn of War DE has classic, modern, and gridkeys.
// Need to research gridkeys, as that might also assume grid design in the UI.
// players are likely to want want all these options.

const SHIFT = true
const CTRL = true

export default function createDefaultActionBindings() {
  const actionBindings: ActionBinding[] = [
    createActionBinding(InputActionType.Escape, createKeyboardBinding("Escape")),
    createActionBinding(InputActionType.Delete, createKeyboardBinding("Delete")),
    createActionBinding(InputActionType.Duplicate, createKeyboardBinding("KeyD")),
    createActionBinding(InputActionType.RotateClockwise, createKeyboardBinding("KeyR")),
    createActionBinding(InputActionType.RotateCounterClockwise, createKeyboardBinding("KeyR", SHIFT)),
    createActionBinding(InputActionType.EndTurn, createKeyboardBinding("Enter", SHIFT)),
    createActionBinding(InputActionType.StartTurn, createKeyboardBinding("Enter")),
    createActionBinding(InputActionType.Primary, createMouseClickBinding(MouseButton.PRIMARY)),
    createActionBinding(InputActionType.Primary, createKeyboardBinding("Enter")),
    // createActionBinding(InputActionType.Secondary, createKeyboardBinding("Enter")),

    createActionBinding(InputActionType.RotateClockwise, createKeyboardBinding("KeyR")),

    createActionBinding(InputActionType.CameraDefaultPolarAngle, createKeyboardBinding("Backspace")),
    createActionBinding(InputActionType.CameraTopDownPolarAngle, createKeyboardBinding("KeyT", SHIFT)),

    createActionBinding(InputActionType.CameraRotateClockwise, createKeyboardBinding("BracketLeft")),
    createActionBinding(InputActionType.CameraRotateCounterClockwise, createKeyboardBinding("BracketRight")),
    createActionBinding(InputActionType.CameraIncreaseFov, createKeyboardBinding("BracketLeft", SHIFT)),
    createActionBinding(InputActionType.CameraDecreaseFov, createKeyboardBinding("BracketRight", SHIFT)),
    createActionBinding(InputActionType.CameraIncreaseFar, createKeyboardBinding("BracketLeft", SHIFT, CTRL)),
    createActionBinding(InputActionType.CameraDecreaseFar, createKeyboardBinding("BracketRight", SHIFT, CTRL)),

    // Zoom
    createActionBinding(InputActionType.CameraIncreaseZoom, createKeyboardBinding("PageUp")),
    createActionBinding(InputActionType.CameraDecreaseZoom, createKeyboardBinding("PageDown")),

    createActionBinding(InputActionType.CameraIncreasePixelation, createKeyboardBinding("PageUp", SHIFT)),
    createActionBinding(InputActionType.CameraDecreasePixelation, createKeyboardBinding("PageDown", SHIFT)),

    createActionBinding(InputActionType.ActionLogMenu, createKeyboardBinding("KeyN", SHIFT)),
    createActionBinding(InputActionType.CenterToPosition, createKeyboardBinding("Quote")),

    // Game actions
    createActionBinding(InputActionType.RotateNextHome, createKeyboardBinding("Home")),
    createActionBinding(InputActionType.UnitWait, createKeyboardBinding("KeyW")),
    createActionBinding(InputActionType.CommitMove, createKeyboardBinding("KeyC")),
    createActionBinding(InputActionType.UnitPickup, createKeyboardBinding("KeyP")),
    createActionBinding(InputActionType.UnitLoad, createKeyboardBinding("KeyL")),
    createActionBinding(InputActionType.UnitUnload, createKeyboardBinding("KeyU")),
    createActionBinding(InputActionType.UnitAnnex, createKeyboardBinding("KeyA")),
    createActionBinding(InputActionType.UnitBombard, createKeyboardBinding("KeyB")),
    createActionBinding(InputActionType.UnitMerge, createKeyboardBinding("KeyM")),

    createActionBinding(InputActionType.PlayersList, createKeyboardBinding("KeyL", SHIFT)),

    createActionBinding(InputActionType.SelectInspectTool, createKeyboardBinding("KeyI")),
    createActionBinding(InputActionType.SelectPaintTool, createKeyboardBinding("KeyP")),
    createActionBinding(InputActionType.SelectEraseTool, createKeyboardBinding("KeyE")),
    createActionBinding(InputActionType.SelectFileTool, createKeyboardBinding("KeyF")),
    createActionBinding(InputActionType.SelectToolsTool, createKeyboardBinding("KeyT")),
    createActionBinding(InputActionType.SelectPlayersTool, createKeyboardBinding("KeyL", SHIFT)),
    createActionBinding(InputActionType.SelectAll, createKeyboardBinding("KeyA", SHIFT)),
    // createActionBinding(InputActionType.SelectNone, createKeyboardBinding("KeyN", SHIFT)), // already bound to action log menu
    createActionBinding(InputActionType.InvertSelection, createKeyboardBinding("KeyI", SHIFT)),
  ]

  return actionBindings
}
